const COUPONS = {
  BADGES: {
    APP_ONLY: '📱 Exclusivo', // For now is being used  as a tag
  },
  COUPON_WITH_NO_CODE: 'Link cuponado',
  COUPONS_LIMIT: 16,
  COUPONS_STORE_GA_EVENT_CATEGORY: 'coupons_store',
  DOMAIN: 'coupon',
  PROMOBIT_COUPON_CODE: 'promobit',
  STATUS: {
    APPROVED: 'APPROVED',
    FINISHED: 'FINISHED',
  },
  VISIBILITY_STATUS: {
    ALL: 'ALL',
    APP_ONLY: 'APP_EXCLUSIVE',
    LOGGED_ONLY: 'LOGGED',
    UNLOGGED_ONLY: 'UNLOGGED',
  },
};

export default COUPONS;
